import { useLocalStorageContext } from "@/contexts/LocalStorage";

import useAvailableOrganisations from "./useAvailableOrganisations";

export default function useOrganisationWithoutUrlParam() {
  const { getStorage } = useLocalStorageContext();

  const organisationIdInLocalStorage = getStorage("selectedOrganisationId");

  const [availableOrganisations, { loading }] = useAvailableOrganisations();

  if (!availableOrganisations?.length) return [undefined, { loading }];

  const organisation =
    availableOrganisations.find(org => org.id == organisationIdInLocalStorage) ||
    availableOrganisations[0]; // i.e. use one defined in local storage
  // or get first available

  return [organisation, { loading }];
}
